import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetFileToDownloadQuery } from "@/store/api";
import CaseUpdateForm from "./caseUpdateForm";
import { FunctionDetailComponents } from "./functionDetailComponent";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import CaseUpdatesList from "./caseUpdateList";
var getSafeHtmlWithoutScript = function (html) {
    return DOMPurify.sanitize(html, { FORBID_TAGS: ["script"] });
};
/** <b>Composant en mode consultation/detail d'un champ de type function</b>*/
export default function FunctionFieldDetail(_a) {
    var fieldName = _a.fieldName, fieldMetadata = _a.fieldMetadata, fieldDef = _a.fieldDef, viewType = _a.viewType, record = _a.record, onUpdate = _a.onUpdate, moduleName = _a.moduleName;
    var cleanHtml = getSafeHtmlWithoutScript(fieldMetadata.value);
    var _b = useState(""), fileData = _b[0], setFileData = _b[1];
    var _c = useGetFileToDownloadQuery({
        params: {
            id: "551d2640-097f-88b3-7aa7-6889be64873b",
            type: "Notes",
        },
    }), file = _c.data, error = _c.error;
    useEffect(function () {
        setFileData(file === null || file === void 0 ? void 0 : file.data.output);
    }, [file]);
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    if (fieldName === "aop_case_updates_threaded") {
        return (_jsxs(_Fragment, { children: [_jsx(CaseUpdatesList, { caseId: record === null || record === void 0 ? void 0 : record.id, refreshKey: refreshKey }), _jsx(CaseUpdateForm, { viewType: viewType, record: record, moduleName: moduleName, fieldName: fieldName, onUpdate: onUpdate, fieldMetadata: fieldMetadata, fieldDef: fieldDef, onSaved: function () { return setRefreshKey(function (k) { return k + 1; }); } })] }));
    }
    else {
        return (_jsx(_Fragment, { children: _jsx(FunctionDetailComponents, { fieldName: fieldName, fieldDef: fieldDef, viewType: viewType, record: record, onUpdate: onUpdate, moduleName: moduleName }) }));
    }
}
